export const DISABLE_LIST_QUERY_OPTIONS = {
  staleTime: Infinity,
  initialData: {
    data: [],
    total: 0,
  },
};
